module.exports = __webpack_public_path__ + "img/alert-circle.aeb43a1a.svg";